var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8048 4.19526C14.0652 4.45561 14.0652 4.87772 13.8048 5.13807L7.13815 11.8047C6.8778 12.0651 6.45569 12.0651 6.19534 11.8047L2.86201 8.4714C2.60166 8.21106 2.60166 7.78894 2.86201 7.5286C3.12236 7.26825 3.54447 7.26825 3.80482 7.5286L6.66675 10.3905L12.862 4.19526C13.1224 3.93491 13.5445 3.93491 13.8048 4.19526Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1f96d0c8a90de6d34038d41badeb88af.svg";
export { ForwardRef as ReactComponent };